import invariant from "tiny-invariant";

import type { Nullable, TNone } from "~/types/common";

export function assertIsNotNone<T>(value: T, name: string): asserts value is Exclude<T, TNone> {
  invariant(!isNone(value), `Expected "${name}" to not be 'None'`);
}

export function isNone(value: unknown): value is TNone {
  return typeof value == "string" && value == "None";
}

export function isNotNoneString(value: unknown): value is string {
  return typeof value == "string" && value.length > 0 && !isNone(value);
}

export function isNullableOrNone(value: unknown): value is Nullable<TNone> {
  return value == null || isNone(value);
}

export function coalesceNone<T, U>(value: T, defaultValue: U): Exclude<T, TNone> | U {
  return isNone(value) ? defaultValue : (value as Exclude<T, TNone>);
}
